var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiDialog from '@material-ui/core/Dialog';
/**
 * Kareo wrapped component of the Material-UI Dialog. The prop API has been limited to props defined in DialogProps.
 *
 * Dialogs inform users about a task and can contain critical information, require decisions, or involve multiple tasks.
 *
 * Material-UI Dialog: [Docs](https://v4.mui.com/components/dialogs/), [API](https://v4.mui.com/api/dialog/)
 *
 * @storybook: [Dialog](http://design.kareoprod.ent/design-system/?path=/story/components-feedback-dialog)
 */
var Dialog = React.forwardRef(function (props, ref) {
    return React.createElement(MuiDialog, __assign({}, props, { ref: ref }));
});
Dialog.defaultProps = {
    maxWidth: 'sm',
};
Dialog.displayName = 'KareoDialog';
export default Dialog;
